import { render, staticRenderFns } from "./BlogCards.vue?vue&type=template&id=299f7230"
import script from "./BlogCards.vue?vue&type=script&lang=js"
export * from "./BlogCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports